
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgbModal, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserService } from '@services/core/user.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { CampusService } from '@services/campus.service';
import { EntityService } from '@services/entity.service';

@Component({
  selector: 'app-user-management',
  templateUrl: './users.component.html',
  styleUrls: ["./users.component.css"],
  imports: [DragDropModule, FormsModule, NgSelectModule, NgbTooltipModule, PanelComponent, ReactiveFormsModule],
  providers: [UserService, CampusService, EntityService],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersManagementComponent implements OnInit {
  // @Input() period
  // @Input() entity

  private _userService = inject(UserService)
  private _campusService = inject(CampusService)
  private _entityService = inject(EntityService)
  private _fb = inject(FormBuilder)
  private _modalService = inject(NgbModal)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  protected users = []
  protected search = ""
  protected roles: any
  protected offices: any
  protected entities: any
  private today = new Date()
  protected dateExpiration: any
  protected minDate = new Date().toISOString().split('T')[0]

  private modalOptions = {
    size: 'xl',
    scrollable: true,
    animation: true,
    backdrop: true
  }
  public closeResult = ""
  protected newUserForm = this._fb.group({
    _id: [null],
    mail: ["", Validators.required],
    roleId: ["", Validators.required],
    campusId: ["", Validators.required],
    entityId: ["", Validators.required],
    dateExpiration: [null],
    enabled: [true],
  })

  // protected certpro
  // protected showEditCategory = false
  // protected items
  // protected item_sel
  // protected certProTypes
  // protected typeCertPro
  // public closeResult = ""
  // public question = ""



  ngOnInit(): void {
    this.getRoles();
    this.getCampus();
    this.getEntities();
    this.dateExpiration = new Date(this.today.setFullYear(this.today.getFullYear() + 1)).toISOString().split('T')[0]
  }

  open(modal: any, data?: any) {
    this.newUserForm.patchValue(data);
    if(!data.dateExpiration) this.newUserForm.patchValue({dateExpiration: this.dateExpiration})
      else this.newUserForm.patchValue({dateExpiration: data.dateExpiration})
    this._modalService.open(modal, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  getRoles() {
    this._userService.getRoles().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((roles) => {
      this.roles = roles;
      this.cdr.markForCheck();
    });
  }

  getCampus() {
    this._campusService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((offices) => {
      this.offices = offices;
      this.cdr.markForCheck();
    });
  }

  getEntities() {
    this._entityService.getAll().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((entities) => {
      this.entities = entities;
      this.cdr.markForCheck();
    });
  }

  getUsers() {
    this._userService.getUsers(this.search).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((users) => {
      this.users = users;
      this.cdr.markForCheck();
    });
  }

  saveUser() {
    if (this.newUserForm.value._id === null) {
      this._userService.createUser(this.newUserForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((user) => {
        this.newUserForm.reset();
        this.getUsers();
        this.cdr.markForCheck();
      });
    } else {
      this._userService.updateUser(this.newUserForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((user) => {
        this.newUserForm.reset();
        this.getUsers();
        this.cdr.markForCheck();
      });
    }

  }

  updateUser(user: any, enabled: boolean) {
    if (enabled) user.enabled = enabled;
    this._userService.updateUser(user).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((user) => {
      this.getUsers()
    });
  }

} 
